import { render, staticRenderFns } from "./ProductLine.vue?vue&type=template&id=ece35772&"
import script from "./ProductLine.vue?vue&type=script&lang=js&"
export * from "./ProductLine.vue?vue&type=script&lang=js&"
import style0 from "./ProductLine.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductLine.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib'
installComponents(component, {
  VCombobox,
})
